module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-regular.bf2e21abbed7a69a2c88.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.eot
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.eot
// module chunks = styles